module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/service-c8cdd52d4eb7dc0d5658e753635090ee.jpg";